import React from "react";

import { DashboardPageTemplate } from "../../Utils/DashboardPageTemplate";

export const ProductGroupsDashboard = () => {
  return (
    <DashboardPageTemplate pageName={"productGroups"} showCogsWarning={true} />
  );
};
